import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';

import { IHomeData } from '~/src/components/BlockInternet/constants';

import { IQuestion } from '../internet/internet-represent';

enum EWiFiVariant {
    WiFi5 = 'Wi-Fi 5',
    WiFi6 = 'Wi-Fi 6',
    Mesh = 'Mesh-систему',
}

const definitionLink = (data: EWiFiVariant) => {
    const link = () => {
        switch (data) {
            case EWiFiVariant.WiFi5:
                return 'wifi-router-tp-link-archer-ec220g5ert?withOption=0';
            case EWiFiVariant.WiFi6:
                return 'marshrutizator-wifi-d-link-dir-x1530-ru-a';
            case EWiFiVariant.Mesh:
                return 'wifi-system-tp-link-deco-m4?withOption=0';
        }
    };

    const url = `/internet/equipment/${link()}`;
    return `<a href=${url} passHref>${data}</a>`;

};

export const routersAdvs: IHomeData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: '/static/images/equipment/reliability.png',
        webpUrl: '/static/images/equipment/reliability.webp',
        title: 'Положитесь на&nbsp;Wi-Fi',
        subText: 'Переходите из&nbsp;комнаты в&nbsp;комнату во&nbsp;время видеоконференций. Картинка и&nbsp;звук не&nbsp;зависнут и&nbsp;не&nbsp;оборвутся.',
        color: `${COLORS.black}`,
    },
    {
        id: 2,
        imgUrl: '/static/images/equipment/stability.png',
        webpUrl: '/static/images/equipment/stability.webp',
        title: 'Почувствуйте стабильность',
        subText: 'Наслаждайтесь стабильным интернетом для онлайн-игр и&nbsp;прямых трансляций с&nbsp;безупречным видео и&nbsp;чистым звуком.',
        color: `${COLORS.black}`,
    },
    {
        id: 2,
        imgUrl: '/static/images/equipment/control.png',
        webpUrl: '/static/images/equipment/control.webp',
        title: 'Держите всё под контролем',
        subText: 'Используйте чёрный список, чтобы уберечь детей от&nbsp;нежелательного контента.',
        color: `${COLORS.black}`,
    },
    {
        id: 4,
        imgUrl: '/static/images/equipment/safety.png',
        webpUrl: '/static/images/equipment/safety.webp',
        title: 'Ничего не бойтесь',
        subText: 'Наши роутеры защищены от&nbsp;кибератак, взломов и&nbsp;соответствуют самым высоким требованиям безопасности.',
        color: `${COLORS.black}`,
    },
];

export const faqData: IQuestion[] = [
    {
        id: 1,
        question: 'Какой роутер подойдёт для однокомнатной квартиры?',
        answer: `Если у&nbsp;вас однокомнатная квартира, и&nbsp;вы&nbsp;сидите в&nbsp;сети с&nbsp;ноутбука и&nbsp;телефона&nbsp;&mdash;
            вам подойдёт роутер с&nbsp;${definitionLink(EWiFiVariant.WiFi5)}, поддерживающий скорость на&nbsp;уровне 300&nbsp;Мбит/с. К&nbsp;нему можно подключить
            до&nbsp;10&nbsp;устройств.`,
    },
    {
        id: 2,
        question: 'Какой роутер выбрать, если у меня несколько комнат в квартире?',
        answer: `Если в&nbsp;вашей квартире две комнаты&nbsp;&mdash; вам подойдёт роутер с&nbsp;${definitionLink(EWiFiVariant.WiFi5)}, поддерживающий скорость на&nbsp;уровне
            300&nbsp;Мбит/с. А&nbsp;если больше трёх комнат&nbsp;&mdash; выбирайте модель с&nbsp;${definitionLink(EWiFiVariant.WiFi6)}, поддерживающую скорость на&nbsp;уровне
            600&nbsp;Мбит/с, или ${definitionLink(EWiFiVariant.Mesh)} с&nbsp;двумя или тремя блоками.`,
    },
    {
        id: 3,
        question: 'Какой роутер подойдёт для большой площади частного дома?',
        answer: 'Для дома с&nbsp;большой площадью и&nbsp;сложной планировкой подойдут домашняя сеть Wi-Fi или Wi-Fi Mesh-система.',
    },
    {
        id: 4,
        question: 'Как выбрать и установить роутер для эффективной работы?',
        answer: `Инженеры Дом.ру изучат планировку квартиры, а&nbsp;затем установят и&nbsp;настроят оборудование так, чтобы сигнал был стабильный в&nbsp;любой
            точке&nbsp;&mdash; от&nbsp;кухни до&nbsp;балкона.`,
    },
    {
        id: 5,
        question: 'В каких диапазонах работают роутеры?',
        answer: `У&nbsp;каждого роутера два диапазона: 2,4&nbsp;ГГц и&nbsp;5&nbsp;ГГц. Чтобы получить скорость без помех от&nbsp;соседних сетей и&nbsp;бытовых
            приборов&nbsp;&mdash; выберите в&nbsp;списке сеть с&nbsp;диапазоном 5&nbsp;ГГц и&nbsp;подключите к&nbsp;ней своё устройство.`,
    },
    {
        id: 6,
        question: 'Защищены ли роутеры от кибератак и взломов?',
        answer: 'Все Wi-Fi роутеры соответствуют самым высоким требованиям безопасности и&nbsp;препятствуют появлению киберугроз для вашей домашней сети.',
    },
    {
        id: 7,
        question: 'Кому доступна бесплатная доставка?',
        answer: `Мы&nbsp;доставляем роутеры по&nbsp;всей России. Если пользуетесь нашими услугами&nbsp;&mdash; доставка для вас будет бесплатной, а&nbsp;если
            нет&nbsp;&mdash; платной. Стоимость доставки будет зависеть от&nbsp;выбранного адреса.`,
    },
];
